<template>
  <div class="full">
    <HybridList class="full" @create="onCreate" @loadmore="onLoadMore" v-if="list && APIs" :list="list" :APIs="APIs" @select="onSelect"></HybridList>
  </div>
</template>

<script>
import * as wAPI from './wAPI'
export default {
  components: {
    HybridList: require('./HybridList.vue').default
  },
  data () {
    return {
      APIs: {},
      list: [],
      currentID: false
    }
  },
  methods: {
    onSelect () {

    },
    onCreate ({ text }) {
      let newItem = {
        _id: wAPI.getID(),
        idx: this.list.length,
        text
      }
      this.list.unshift(newItem)
    },
    onLoadMore () {
      let newItem = {
        _id: wAPI.getID(),
        idx: this.list.length,
        text: `1236789`
      }
      this.list.push(newItem)
      window.dispatchEvent(new Event('scroll-to-bottom'))
    },
    load () {
      setTimeout(() => {
        let collections = wAPI.aphorismCollections()
        collections.forEach((coll) => {
          coll.quotes.slice().forEach((e) => {
            e.idx = this.list.length
            this.list.push(e)
          })
        })

        this.currentID = this.list[0]._id
        this.$forceUpdate()
      }, 100)
    }
  },
  mounted () {
    this.load()
  }
}
</script>

<style>

</style>
